import { obterParametrosDaURL } from "../../../../functions";
import { apiAssinaturaDigital } from "../../api";
import { ApiException } from "../../api-exception";

export interface IResumoOrcamentoRequest {
  NumOrc: number;
  CodLoja: number;
}

export const VerificarSolicitacaoRespondida = async ({
  NumOrc,
  CodLoja,
}: IResumoOrcamentoRequest): Promise<boolean> => {
  const { token } = obterParametrosDaURL();

  try {
    const { data } = await apiAssinaturaDigital.get<boolean>(
      `/Orcamento/verificarsolicitacaorespondida`,
      {
        params: { NumOrc, CodLoja },
        headers: { token },
      }
    );

    return data;
  } catch (erro) {
    throw new ApiException(
      erro,
      "Não foi possível verificar se a solicitação já foi respondida por outro gerente"
    );
  }
};